<template>
  <s-modal
    v-model="showModal"
    :title="$t('reports.new-report-import')"
    size="lg"
    hide-footer
  >
    <b-container fluid>
      <b-row
        no-gutters
        class="dropzone__title no-internal-print"
      >
        <dropzone
          :input-accept="inputAccept"
          :title="$t('actions.import-file')"
          :isMultipleUpload="isMultipleUpload"
          @input="newFilesAdded"
        />
      </b-row>
    </b-container>

  </s-modal>
</template>

<script>
import Dropzone from '@/components/Dropzone';

export default {
  name: 'ImportTemplateModal',
  components: {
    Dropzone,
  },
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false,
    },
    isMultipleUpload: {
      type: Boolean,
      required: true,
      default: false,
    },
    inputAccept: {
      type: Array,
      required: true,
      default: () => ['.json'],
    },
  },
  computed: {
    showModal: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    newFilesAdded(file) {
      this.$emit('fileUploaded', file);
    },
  },
};
</script>

<style lang="sass" scoped>
::v-deep .modal-header
  display: block

@page
  margin: 0 auto

  @media print
    .modal-dialog,
    .modal-content
      max-width: 100vw
      width: 100vw
      height: 100vh
      margin: 0 auto

    .modal-content
      position: absolute
      top: 0
      left: 0
      right: 0
      bottom: 0
</style>
